"use client";

import { AdditionalInfoTabProps } from './types';
export const AdditionalInfoTab = ({ details }: AdditionalInfoTabProps) => {
  return (
    <div className="space-y-4">
      <h3 className="text-lg font-semibold text-black">Additional Information</h3>
      <div className="space-y-3">
        <div className="flex justify-between py-2 border-b border-gray-100">
          <span className="text-gray-600">Material</span>
          <span className="text-black font-medium text-right">{details.material}</span>
        </div>
        <div className="flex justify-between py-2 border-b border-gray-100">
          <span className="text-gray-600">Care Instructions</span>
          <span className="text-black font-medium text-right">{details.careInstruction}</span>
        </div>
        <div className="flex justify-between py-2 border-b border-gray-100">
          <span className="text-gray-600">Origin</span>
          <span className="text-black font-medium text-right">{details.origin}</span>
        </div>
        <div className="flex justify-between py-2">
          <span className="text-gray-600">Fit</span>
          <span className="text-black font-medium text-right">{details.fit}</span>
        </div>
      </div>
    </div>
  );
}; 